import { useState, useEffect } from "react";
import { loadIssueDetail } from "../services/issueIndentService";
import { loadPurchaseDetail } from "../services/purchaseIndentService";

const useLoadPurchaseIndentDetailByRequestIndent=()=> {
    const [RequestIndentDetail, setRequestIndentDetail] = useState([]);   

    // Fetch department data
    const fetchPurchaseDetail = async (selectedID = null,request_indent_number) => {
        const para = { 
            p_companyid: localStorage.getItem("companyid"),
            p_plantid:1,
            p_id_request:selectedID,
            p_purchase_indent_number:request_indent_number,
        };

        try {
            const data = await loadPurchaseDetail(para);
            if (data && data.length > 0) {
                setRequestIndentDetail(data);          

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };   

    // Function to load department based on selected ID
    const loadPurchaseDetailByRequestIndentID = async (selectedID,request_indent_number) => {
        await fetchPurchaseDetail(selectedID,request_indent_number);
    };

    return {
         RequestIndentDetail,       
         loadPurchaseDetailByRequestIndentID,
    };
};

export default useLoadPurchaseIndentDetailByRequestIndent;
